/* Оглавление статьи: строится из h2[id] внутри {{content}} (.prose).
   Koenig сам проставляет id заголовкам. Контейнер — <nav data-toc> в post.hbs;
   активный пункт подсвечивает IntersectionObserver (перенос из Article.html). */
export default function toc() {
    const nav = document.querySelector("[data-toc]");
    const prose = document.querySelector(".prose");
    const aside = document.querySelector(".art-aside");
    if (!nav || !prose) return;

    const heads = prose.querySelectorAll("h2[id]");
    if (!heads.length) {
        if (aside) aside.style.display = "none";
        return;
    }

    const byId = {};
    heads.forEach((h) => {
        const a = document.createElement("a");
        a.href = "#" + h.id;
        a.textContent = h.textContent;
        nav.appendChild(a);
        byId[h.id] = a;
    });

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                nav.querySelectorAll("a").forEach((a) => a.classList.remove("on"));
                const link = byId[entry.target.id];
                if (link) link.classList.add("on");
            });
        },
        { rootMargin: "-20% 0px -70% 0px" }
    );
    heads.forEach((h) => observer.observe(h));
}
